import { Caption, cn } from '@vrzl/ui';

import { emptyColumnsClass } from '../constants';

type RowHintProps = {
  /** Bezette kolommen in de rij. */
  used: number;
  /** Lege kolommen achter het laatste blok van de rij. */
  empty: number;
};

/**
 * Staat in het lege deel van een rij met een kwartblok die niet vol is. Alleen voor de editor: de Overview
 * rekt geen blokken uit om gaten te vullen, dus de Beheerder ziet hier waar ruimte openblijft.
 */
export function RowHint({ used, empty }: RowHintProps) {
  return (
    <div
      className={cn(
        'flex items-center justify-center self-start rounded-lg border border-dashed border-border px-3 py-2 text-center',
        emptyColumnsClass[empty],
      )}
    >
      <Caption tone="subtle">Rij niet vol: {used} van 4 kolommen bezet</Caption>
    </div>
  );
}
